import { Component, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RenderedOutputSummary } from 'situview-webapi-client';

/** Optional — callers that just want any rendered output can omit it entirely. */
export interface ISituReelItemPickerDialogData {
  /** Heading shown above the browser. */
  title?: string;
  /** Pre-filter the browser to a single style template (e.g. a scratch template's history). */
  styleConfigTemplateId?: string;
}

@Component({
  selector: 'situ-reel-item-picker-dialog',
  templateUrl: './situ-reel-item-picker-dialog.component.html',
  styleUrls: ['./situ-reel-item-picker-dialog.component.scss']
})
export class SituReelItemPickerDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<SituReelItemPickerDialogComponent, RenderedOutputSummary>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: ISituReelItemPickerDialogData | null) {}

  get title(): string {
    return this.data?.title || 'Pick a rendered output';
  }

  onPicked(renderedOutput: RenderedOutputSummary): void {
    if (renderedOutput) {
      this.dialogRef.close(renderedOutput);
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
